import {CourtSide} from "./court-info.type";
import {PlayerStatsDto} from "../dtos/player.dto";

export interface PlayerInfo {
  id: number;
  firstName: string;
  lastName: string;
  number?: number;
}

export type PlayerWithSideInfo = PlayerInfo & { side: CourtSide };

export const createEmptyPlayerStats = (): PlayerStatsDto => ({
  serving: {
    opportunities: 0,
    pointsWon: 0,
    errors: 0,
    aces: 0,
    acePercentage: 0,
    opponentOutOfSystemPasses: 0,
    knockoutPercentage: 0,
    efficiencyPercentage: 0,
    transitionWinPercentage: 0,
  },
  firstBallSideout: {
    opportunities: 0,
    kills: 0,
    errors: 0,
    percentage: 0,
    efficiencyPercentage: 0,
  },
  sideout: {
    opportunities: 0,
    kills: 0,
    errors: 0,
    percentage: 0,
    transitionWinPercentage: 0,
    aced: 0,
    pointsWon: 0,
  }
});

export const IGNORE_PLAYER_ID = -1;